import { cn } from "@z/ui";

/** A Things-style pie: the outer ring stays visible even for an empty project. */
export function ProjectProgress({
  completed,
  total,
  className,
}: {
  completed: number;
  total: number;
  className?: string;
}) {
  const fraction = total > 0 ? Math.min(1, Math.max(0, completed / total)) : 0;
  const angle = fraction * Math.PI * 2;
  const x = 10 + 6.5 * Math.sin(angle);
  const y = 10 - 6.5 * Math.cos(angle);
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className={cn("size-4 shrink-0", className)}>
      <circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
      {fraction === 1 ? (
        <circle cx="10" cy="10" r="6.5" fill="currentColor" />
      ) : fraction > 0 ? (
        <path
          d={`M10 10 L10 3.5 A6.5 6.5 0 ${fraction > 0.5 ? 1 : 0} 1 ${x} ${y} Z`}
          fill="currentColor"
        />
      ) : null}
    </svg>
  );
}
